import { forwardRef, type ReactNode } from 'react';

import {
	Unstable_NumberInput as BaseNumberInput,
	type NumberInputProps as BaseNumberInputProps,
} from '@mui/base/Unstable_NumberInput';
import { Button } from '@vakantiesnl/components/src/atoms/Button';
import { InputComponent } from '@vakantiesnl/components/src/atoms/Input';

import { useStyles } from './NumberInput.styles';

export type NumberInputProps = BaseNumberInputProps & {
	dataCy?: string;
	defaultValue?: number;
};

export const NumberInput = forwardRef(function CustomNumberInput(
	{ dataCy, defaultValue, ...props }: NumberInputProps,
	ref: React.ForwardedRef<HTMLDivElement>,
): ReactNode {
	const { classes, cx } = useStyles();

	return (
		<BaseNumberInput
			data-cy={`${dataCy}-select`}
			// eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
			slots={{
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
				root: ({ ownerState, className, children, ...props }) => (
					<div className={cx(className, classes.numberInputRoot)} {...props}>
						{children}
					</div>
				),
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
				decrementButton: ({ ownerState, ...props }) => (
					<Button trailingIcon="minus" size="small" variant="secondary" {...props} />
				),
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
				input: ({ ownerState, ...props }) => (
					<InputComponent
						label="amount"
						inputSize="small"
						value={props.value}
						readOnly
						aria-readonly
						{...props}
						className={cx(props.className, classes.inputinput)}
						disabled
					/>
				),
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
				incrementButton: ({ ownerState, ...props }) => (
					<Button
						trailingIcon="plus"
						size="small"
						variant="secondary"
						{...props}
						className={cx(props.className, classes.increment)}
					/>
				),
			}}
			value={defaultValue ?? 0}
			{...props}
			ref={ref}
		/>
	);
});
